module.exports = __webpack_public_path__ + "static/media/sanlam-real-assets.aac057ee.csv";